import type { ReactNode } from "react";
import Box from "@mui/material/Box";

type NiyaazFormLayoutProps = {
  hof: ReactNode;
  main: ReactNode;
  people: ReactNode;
  sidebarExtra?: ReactNode;
};

/**
 * Mobile: HOF → people → previous history → takhmeen/payment (main).
 * Desktop (md+): left column = HOF + main stacked; right column = sidebar extra + people.
 *
 * Column wrappers use `display: contents` on xs so children participate in the parent
 * grid via `gridRow` without duplicating ArrayInput fields.
 */
export const NiyaazFormLayout = ({ hof, main, people, sidebarExtra }: NiyaazFormLayoutProps) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
      gap: 2.5,
      mt: 1,
      pb: 2,
      alignItems: "start",
    }}
  >
    <Box
      sx={{
        display: { xs: "contents", md: "flex" },
        flexDirection: "column",
        gap: 2.5,
        gridColumn: { md: 1 },
        minWidth: 0,
      }}
    >
      <Box sx={{ gridRow: { xs: 1 } }}>{hof}</Box>
      <Box sx={{ gridRow: { xs: 4 } }}>{main}</Box>
    </Box>

    <Box
      sx={{
        display: { xs: "contents", md: "flex" },
        flexDirection: "column",
        gap: 2.5,
        gridColumn: { md: 2 },
        borderLeft: { xs: "none", md: 1 },
        borderColor: "divider",
        pl: { xs: 0, md: 2 },
        minWidth: 0,
      }}
    >
      {sidebarExtra ? <Box sx={{ gridRow: { xs: 3 }, minWidth: 0 }}>{sidebarExtra}</Box> : null}
      <Box sx={{ gridRow: { xs: 2 }, minWidth: 0 }}>{people}</Box>
    </Box>
  </Box>
);
